import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { EditProjectData } from '../components/create-project-panel/create-project-panel.component';

@Injectable({
  providedIn: 'root'
})
export class ProjectPanelService {
  private editProjectSubject = new Subject<EditProjectData>();
  private openCreatePanelSubject = new Subject<void>();
  
  public editProject$ = this.editProjectSubject.asObservable();
  public openCreatePanel$ = this.openCreatePanelSubject.asObservable();

  public openEditPanel(project: EditProjectData): void {
    this.editProjectSubject.next(project);
  }

  public openCreatePanel(): void {
    this.openCreatePanelSubject.next();
  }
}
